module.exports = __webpack_public_path__ + "static/media/product-1-back.bebca9ff.jpg";